import { useWorkspaceId } from '../auth/WorkspaceState';

const pricingBlockedWorkspaceIds = new Set(['4b5a8791-6c4a-4d40-93f3-6df2b38c35c3']);

export function isPricingBlockedWorkspace(workspaceId: string | undefined): boolean {
  return !!workspaceId && pricingBlockedWorkspaceIds.has(workspaceId);
}

export function useIsPricingBlocked(): boolean {
  const workspaceId = useWorkspaceId();
  return isPricingBlockedWorkspace(workspaceId);
}
